import vtkSTLReader from './STLReader';
import vtkPLYReader from './PLYReader';
import vtkDracoReader from './DracoReader';
import vtkSTLWriter from './STLWriter';
import vtkPLYWriter from './PLYWriter';

export default {
  vtkSTLReader,
  vtkPLYReader,
  vtkDracoReader,
  vtkSTLWriter,
  vtkPLYWriter,
};
